export const DOWNLOAD_OWN_SUBMISSION_TOOLTIP = [
    'You can download only your own submissions until the challenge completes',
    'or fails review.',
].join(' ')
export const VIEW_OWN_SCORECARD_TOOLTIP = 'You can only view scorecards for your own submissions.'
export const VIRUS_SCAN_FAILED_MESSAGE = 'Submission failed virus scan'
